/* eslint-disable */
// @ts-nocheck

// import React from 'react';
import styled from 'styled-components';

import Box from './Box';
import Flex from './Flex';
import { FlexProps } from './types';

export const Col = styled(Flex)<FlexProps>`
  flex-grow: 0;
`;

export const Row = styled(Box)<FlexProps>`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;

  margin-left: ${(props) => `-${(props.gutter || 0) / 2}px`};
  margin-right: ${(props) => `-${(props.gutter || 0) / 2}px`};

  ${Col} {
    padding-left: ${(props) => `${(props.gutter || 0) / 2}px`};
    padding-right: ${(props) => `${(props.gutter || 0) / 2}px`};
  }
`;

export type FlexProps = FlexProps;
export { default as Box } from './Box';
export { default as Flex } from './Flex';
